export default "__VITE_ASSET__BtLccaK1__"